var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29066 6.19775L6.00066 3.90775V11.4948C6.00066 12.0448 5.55066 12.4948 5.00066 12.4948C4.44966 12.4948 4.00066 12.0448 4.00066 11.4948V3.90775L1.70966 6.19775C1.32066 6.58675 0.684656 6.58675 0.295656 6.19775C-0.0933437 5.80875 -0.0933437 5.17275 0.295656 4.78375L4.29366 0.786751C4.35166 0.72675 4.42566 0.694752 4.49366 0.653751C4.53566 0.628752 4.56966 0.592752 4.61566 0.572751C4.65666 0.554751 4.70266 0.554751 4.74566 0.544751C4.95766 0.487751 5.18166 0.488751 5.38566 0.572751C5.42966 0.591751 5.46266 0.626751 5.50366 0.651751C5.57366 0.692751 5.64666 0.725751 5.70766 0.786751L9.70466 4.78375C10.0937 5.17275 10.0937 5.80875 9.70466 6.19775C9.31566 6.58775 8.67966 6.58775 8.29066 6.19775Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.3e7abd66.svg";
export { ForwardRef as ReactComponent };